import { useState, useEffect } from "react";

import { openMenuButton, closeMenuButton } from "components/header";

export const useMenuOverlayClose = (initState?: boolean) => {
  const [menuOverlayOpen, setMenuOverlayOpen] = useState<boolean>(true);

  useEffect(() => {
    const onMenuOverlayOpen = (): void => {
      setMenuOverlayOpen(true);
    };

    const onMenuOverlayClose = (): void => {
      setMenuOverlayOpen(false);
    };

    // listen to menu buttons to update menu open state
    openMenuButton?.addEventListener("click", onMenuOverlayOpen);
    closeMenuButton?.addEventListener("click", onMenuOverlayClose);

    // cleanup event listeners
    return () => {
      openMenuButton?.removeEventListener("click", onMenuOverlayOpen);
      closeMenuButton?.removeEventListener("click", onMenuOverlayClose);
    };
  }, []);

  return { menuOverlayOpen };
};
